import React from 'react';
import Button from '../Button';
import styles from './AddAddressButton.module.scss';

type AddAddressButtonProps = {
  showMaxAddressLabel: boolean;
  handleClick: () => void;
};

const AddAddressButton: React.FC<AddAddressButtonProps> = ({
  showMaxAddressLabel,
  handleClick,
}) => (
  <div className={styles.addMore} data-testid="add-address-button">
    {showMaxAddressLabel ? (
      <Button disabled>MAX 10 ADDRESSES</Button>
    ) : (
      <Button variation="black-outline" onClick={handleClick}>
        <i className="fal fa-plus" />
        ADD ADDRESS
      </Button>
    )}
  </div>
);

export default AddAddressButton;
